import { Link } from 'react-router'

export function DropdownItem({ tag = 'button', to, onClick, onItemClick, className = '', children }) {
  const handleClick = (event) => {
    if (tag === 'button') event.preventDefault()
    if (onClick) onClick()
    if (onItemClick) onItemClick()
  }

  if (tag === 'a' && to) {
    return (
      <Link to={to} className={className} onClick={handleClick}>
        {children}
      </Link>
    )
  }

  return (
    <button onClick={handleClick} className={`block w-full text-left ${className}`}>
      {children}
    </button>
  )
}
